'use client'

import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  // Check if this error was already handled silently by our SilentErrorBoundary
  if ((error as any).__silentlyHandled) {
    // Don't show the error page, just return a minimal fallback
    return (
      <html lang="es">
        <body>
          <div></div>
        </body>
      </html>
    )
  }

  return (
    <html lang="es">
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen bg-srperrito-dark text-white p-4">
          <h2 className="text-4xl font-bold mb-4">¡Algo salió mal!</h2>
          <p className="text-xl mb-8">Ha ocurrido un error global inesperado</p>
          <button
            onClick={() => reset()}
            className="px-6 py-3 bg-white text-srperrito-dark font-bold rounded-lg hover:bg-gray-100 transition-colors"
          >
            Intentar de nuevo
          </button>
        </div>
      </body>
    </html>
  )
}
